import { Injectable, Inject } from 'ng-metadata/core';
/**
 * @ngdoc service
 * @name mwEnvDetectorService
 * @module mw.components.envDetector
 *
 * @property {string} os - The name of the OS.  Common values include 'windows', 'mac', 'ios', 'android'.
 * @property {string} os_version - The OS version.
 * @property {string} browser - The name of the browser.  Common values include 'chrome', 'ie', 'ms-edge', 'firefox', 'safari'.
 * @property {string} browser_version - The browser version.
 * @property {string} device - The device type (if applicable).  Common values include 'android', 'ipad', 'iphone', 'blackberry', 'window-phone'.
 * @property {boolean} isMobile - A flag specifying if environment is determined to be a mobile device.
 * @property {boolean} isTablet - A flag specifying if environment is determined to be a tablet device.
 * @property {boolean} isDesktop - A flag specifying if environment is determined to be a desktop.
 *
 * @description
 * The `mwEnvDetector` service provides information about the environment that the app is running in.
 * Based on the user-agent, it determines the OS, Browser and Device.
 *
 * Internally, the service uses <a href="https://github.com/srfrnk/ng-device-detector">ng-device-detector</a> for determining OS, Browser and Device.
 * Constants for OS, Browser and Device are defined and can be found <a href="https://github.com/srfrnk/ng-device-detector/blob/master/ng-device-detector.js">here</a>.
 *
 * @usage
 * <hljs hljs-language="js">
 * app.controller('MyController', function(mwEnvDetector) {
 *   this.browser = mwEnvDetector.browser;
 *   this.isMobile = mwEnvDetector.isMobile;
 * });
 * </hljs>
 */
/**
 * @ngdoc method
 * @name mwEnvDetectorService#addEnvClassesToElement
 * @param {Object} element JQLite element to add the environment specific classes to.
 *
 * @description
 * Adds environment class identifiers to the passed in element.
 */
@Injectable()
export class EnvDetectorService {
    public browser;
    public browser_version;
    public browser_major_version;
    public device;
    public os;
    public os_version;
    public isDesktop;
    public isMobile;
    public isTablet;

    constructor(@Inject('deviceDetector') deviceDetector) {
        'ngInject';
        this.browser = deviceDetector.browser;
        this.browser_version = deviceDetector.browser_version;
        this.browser_major_version = this.browser_version.substring(0, this.browser_version.indexOf('.'));
        this.device = deviceDetector.device;
        this.os = deviceDetector.os;
        this.os_version = deviceDetector.os_version;
        this.isDesktop = deviceDetector.isDesktop();
        this.isMobile = deviceDetector.isMobile();
        this.isTablet = deviceDetector.isTablet();
    }

    addEnvClassesToElement(element) {
        let osClass = 'os-' + this.os;
        let browserClass = 'browser-' + this.browser;
        let browserVersionClass = 'browser-' + this.browser + this.browser_major_version;
        let deviceClass = 'device-' + this.device;
        let touchClass = (this.isMobile || this.isTablet) ? 'touch' : 'no-touch';

        if (element) {
            if (!element.hasClass(osClass)) {
                element.addClass(osClass);
            }

            if (!element.hasClass(browserClass)) {
                element.addClass(browserClass);
            }

            if (!element.hasClass(browserVersionClass)) {
                element.addClass(browserVersionClass);
            }

            if (!element.hasClass(deviceClass)) {
                element.addClass(deviceClass);
            }

            if (!element.hasClass(touchClass)) {
                element.addClass(touchClass);
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/lib/components/env-detector/env-detector.service.ts